import React from 'react';
import { LibraryContentCard } from 'src/common/components/library/content-card';
import { LibraryContentCardTypeEnum } from 'src/common/components/library/content-card/type.enum';
import { Node } from 'src/common/interfaces/node.interface';
import { functionNoop } from 'src/utils/function/noop';

type DashboardLibrarySyncedStepCardProps = {
  node: Node;
  onUpdate?: () => void;
};

export const DashboardLibrarySyncedStepCard = ({ node, onUpdate }: DashboardLibrarySyncedStepCardProps) => {
  return (
    <LibraryContentCard
      onClick={functionNoop}
      node={node}
      containerClassName='items-start'
      onUpdate={onUpdate}
      type={LibraryContentCardTypeEnum.LIBRARY}
      draggable={false}
      name={node.name?.trim()}
    />
  );
};
